<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      
      <a-form-model-item prop="activityTitle" >
        <span slot="label" ><a-tooltip>{{ $t('活动标题') }}<template slot="title">{{ $t('活动标题') }}</template></a-tooltip> </span>
        <a-input v-model="form.activityTitle" :maxLength="128" :placeholder="$t('请输入')+'活动标题'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="activityCover" >
        <span slot="label" ><a-tooltip>{{ $t('活动封面URL') }}<template slot="title">{{ $t('活动封面URL') }}</template></a-tooltip> </span>
        <oss-upload-single :height="200" :width="360" v-model="form.activityCover" prefix="community" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="activityContent" >
        <span slot="label" ><a-tooltip>{{ $t('活动详情') }}<template slot="title">{{ $t('活动详情') }}</template></a-tooltip> </span>
        <editor v-model="form.activityContent" />
      </a-form-model-item>
      <a-form-model-item prop="activityStatus" >
        <a-form-model-item prop="activityCategory" >
          <span slot="label" ><a-tooltip>{{ $t('活动分类') }}<template slot="title">{{ $t('活动分类') }}</template></a-tooltip> </span>
          <a-select v-model="form.activityCategory" :placeholder="$t('请选择')" allow-clear>
            <a-select-option :value="10">{{ $t('快闪') }}</a-select-option>
            <a-select-option :value="20">{{ $t('漫展') }}</a-select-option>
            <a-select-option :value="30">{{ $t('商圈') }}</a-select-option>
            <a-select-option :value="40">{{ $t('景区') }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <span slot="label" ><a-tooltip>{{ $t('活动状态') }}<template slot="title">{{ $t('活动状态') }}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="signupStartTime" >
        <span slot="label" ><a-tooltip>{{ $t('报名开始时间') }}<template slot="title">{{ $t('报名开始时间') }}</template></a-tooltip> </span>
        <a-date-picker
          style="width: 100%"
          v-model="form.signupStartTime"
          :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="signupEndTime" >
        <span slot="label" ><a-tooltip>{{ $t('报名结束时间') }}<template slot="title">{{ $t('报名结束时间') }}</template></a-tooltip> </span>
        <a-date-picker
          style="width: 100%"
          v-model="form.signupEndTime"
          :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="activityStartTime" >
        <span slot="label" ><a-tooltip>{{ $t('活动开始时间') }}<template slot="title">{{ $t('活动开始时间') }}</template></a-tooltip> </span>
        <a-date-picker
          style="width: 100%"
          v-model="form.activityStartTime"
          :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="activityEndTime" >
        <span slot="label" ><a-tooltip>{{ $t('活动结束时间') }}<template slot="title">{{ $t('活动结束时间') }}</template></a-tooltip> </span>
        <a-date-picker
          style="width: 100%"
          v-model="form.activityEndTime"
          :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
         allow-clear/>
     </a-form-model-item>
     <a-form-model-item prop="addressDetail" >
        <span slot="label" ><a-tooltip>{{ $t('详细地址') }}<template slot="title">{{ $t('详细地址') }}</template></a-tooltip> </span>
        <a-input-search v-model="form.addressDetail" :maxLength="255" :placeholder="$t('请输入')+'详细地址'" readonly @search="showMapModal">
          <a-button slot="enterButton" type="primary" icon="environment">{{ $t('地图选择') }}</a-button>
        </a-input-search>
      </a-form-model-item>
      <a-form-model-item prop="auditReason" >
        <span slot="label" ><a-tooltip>{{ $t('审核/下架原因') }}<template slot="title">{{ $t('审核/下架原因') }}</template></a-tooltip> </span>
        <a-input v-model="form.auditReason" :maxLength="255" :placeholder="$t('请输入')+'审核/下架原因'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" ><a-tooltip>{{ $t('备注') }}<template slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
     <!-- 地图选择弹窗 -->
      <a-modal
        :visible="mapModalVisible"
        :title="$t('选择地址')"
        @ok="handleMapConfirm"
        @cancel="handleMapCancel"
        width="70%"
        :maskClosable="false"
      >
        <div style="margin-bottom: 8px; display: flex; gap: 8px">
          <a-input-search
            v-model="searchKeyword"
            :placeholder="$t('搜索地点')"
            style="flex: 1"
            @search="handleMapSearch"
          >
            <a-button slot="enterButton" type="primary" icon="search">{{ $t('搜索') }}</a-button>
          </a-input-search>
        </div>
        <div v-if="searchResults.length > 0" style="margin-bottom: 8px; max-height: 120px; overflow-y: auto; border: 1px solid #d9d9d9; border-radius: 4px; padding: 4px">
          <a-list :data-source="searchResults" :locale="{ emptyText: '' }">
            <a-list-item slot="renderItem" slot-scope="item" style="cursor: pointer; padding: 8px 12px" @click="selectSearchResult(item)">
              <a-list-item-meta :description="item.address">
                <span slot="title">{{ item.name }}</span>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </div>
        <div style="height: 400px; width: 100%">
          <el-amap
            ref="map"
            :center="mapCenter"
            :zoom="14"
            @click="handleMapClick"
          >
            <el-amap-marker
              v-if="markerPosition"
              :position="markerPosition"
            />
          </el-amap>
        </div>
      </a-modal>
     <!-- end 地图选择弹窗 -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getCommunityGroupActivity, addCommunityGroupActivity, updateCommunityGroupActivity } from '@/api/community/communityGroup/communityGroupActivity'
  import { mapGetters } from 'vuex'
  import CustomDictTag from '@/components/DictCustomTag'
  import { generateFilePath, uploadObject } from '@/api/tool/oss'
  import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
  import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'
  import moment from 'moment'

      import Editor from '@/components/Editor'

  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
      Editor,
      OssUploadSingle
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
    loading: '',
      mapModalVisible: false,
      mapCenter: [116.397428, 39.90923],
      markerPosition: null,
     selectedAddress: '',
      searchKeyword: '',
      searchResults: [],
    // 表单参数
      form: {
        id: null,
        activityTitle: null,
        activityCover: null,
        activityContent: null,
        activityCategory: null,
        activityStatus: 0,
        signupStartTime: null,
        signupEndTime: null,
        activityStartTime: null,
       activityEndTime: null,
        addressDetail: null,
        addressLongitude: null,
        addressLatitude: null,
        pubCity: null,
        pubCityId: null,
        auditReason: null,
        remark: null,
        localeFieldMap: {}
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          activityTitle: [{ required: true, message: this.$t('活动标题') + this.$t('不能为空'), trigger: 'blur' }],
          activityCover: [{ required: true, message: this.$t('活动封面URL') + this.$t('不能为空'), trigger: 'blur' }],
         activityStatus: [{ required: true, message: this.$t('活动状态') + this.$t('不能为空'), trigger: 'blur' }],
         addressDetail: [{ required: true, message: this.$t('详细地址') + this.$t('不能为空'), trigger: 'blur' }],
          auditReason: [{ required: true, message: this.$t('审核/下架原因') + this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
   moment,
   showMapModal () {
     this.mapModalVisible = true
      this.searchKeyword = ''
      this.searchResults = []
     this.$nextTick(() => {
        if (this.form.addressLongitude && this.form.addressLatitude) {
          this.mapCenter = [this.form.addressLongitude, this.form.addressLatitude]
          this.markerPosition = [this.form.addressLongitude, this.form.addressLatitude]
          this.selectedAddress = this.form.addressDetail
        } else {
          this.mapCenter = [116.397428, 39.90923]
          this.markerPosition = null
          this.selectedAddress = ''
        }
      })
    },
    handleMapClick (e) {
      this.markerPosition = [e.lnglat.lng, e.lnglat.lat]
     // 逆地理编码获取地址
      this.searchKeyword = ''
      this.searchResults = []
     const geocoder = new AMap.Geocoder({ city: '', radius: 1000 })
      geocoder.getAddress(e.lnglat, (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          this.selectedAddress = result.regeocode.formattedAddress
          // 从高德地址组件中提取城市名，直辖市等 city 为空时回退到省份
          const addressComponent = result.regeocode.addressComponent || {}
          const city = Array.isArray(addressComponent.city) ? addressComponent.city[0] : addressComponent.city
          this.form.pubCity = city || addressComponent.province || null
          const adcode = Array.isArray(addressComponent.adcode) ? addressComponent.adcode[0] : addressComponent.adcode
          this.form.pubCityId = adcode ? String(adcode) : null
        }
      })
    },
    handleMapConfirm () {
      if (this.markerPosition) {
        this.form.addressLongitude = this.markerPosition[0]
        this.form.addressLatitude = this.markerPosition[1]
        this.form.addressDetail = this.selectedAddress
      }
      this.mapModalVisible = false
    },
   handleMapCancel () {
     this.mapModalVisible = false
   },
    // 搜索地点
    handleMapSearch () {
      if (!this.searchKeyword.trim()) return
      const auto = new AMap.Autocomplete({ city: '', citylimit: true })
      auto.search(this.searchKeyword, (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          this.searchResults = result.tips || []
        }
      })
    },
    // 选中搜索结果
    selectSearchResult (item) {
      if (!item.location) {
        // 部分 tip 没有坐标，再用一次搜索获取
        const placeSearch = new AMap.PlaceSearch({ city: '', citylimit: true })
        placeSearch.getDetails(item.id, (status, result) => {
          if (status === 'complete' && result.info === 'OK' && result.poiList && result.poiList.pois.length > 0) {
            const poi = result.poiList.pois[0]
            this.markerPosition = [poi.location.lng, poi.location.lat]
            this.mapCenter = [poi.location.lng, poi.location.lat]
            this.selectedAddress = poi.pname + poi.cityname + poi.adname + poi.address + poi.name
            this.form.pubCity = poi.cityname || poi.pname || null
            this.form.pubCityId = poi.adcode ? String(poi.adcode) : null
          }
        })
        return
      }
      const lng = item.location.lng
      const lat = item.location.lat
      this.markerPosition = [lng, lat]
      this.mapCenter = [lng, lat]
      this.selectedAddress = item.district + item.address + item.name
      this.form.pubCity = item.cityname || item.pname || null
      this.form.pubCityId = item.adcode ? String(item.adcode) : null
    },
   onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        activityTitle: null,
        activityCover: null,
        activityContent: null,
        activityCategory: null,
        activityStatus: 0,
        signupStartTime: null,
        signupEndTime: null,
        activityStartTime: null,
       activityEndTime: null,
       addressDetail: null,
        addressLongitude: null,
        addressLatitude: null,
        pubCity: null,
        pubCityId: null,
        auditReason: null,
        remark: null,
        localeFieldMap: {}
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityGroupActivity({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityGroupActivity(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCommunityGroupActivity(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>

